import { useSelector } from 'react-redux';
import { RootState } from '../../store';

const focusCloudDarkMode = '/resources/images/loghi/focusCloudDarkMode.png';
const focusCloudWhiteMode = '/resources/images/loghi/focusCloudWhiteMode.png';
const focusCloudSmallDarkMode =
  '/resources/images/loghi/small-logo-DarkMode.png';
const focusCloudSmallWhiteMode =
  '/resources/images/loghi/small-logo-WhiteMode.png';
const logoBludataWhiteMode = '/resources/images/loghi/Bludata-WhiteMode.svg';
const logoBludataDarkMode = '/resources/images/loghi/Bludata-DarkMode.svg';

export const logoFocusCloudDarkModeUrl = focusCloudDarkMode;
export const logoFocusCloudLightModeUrl = focusCloudWhiteMode;
export const logoBludataWhiteModeUrl = logoBludataWhiteMode;
export const logoBludataDarkModeUrl = logoBludataDarkMode;
export const logoFocusCloudSmallDarkModeUrl = focusCloudSmallDarkMode;
export const logoFocusCloudSmallWhiteModeUrl = focusCloudSmallWhiteMode;

export const logoIMOUrl =
  'https://www.bludata.com/images/repository/loghi/logo_IMO.png';

const useBludataLogoThemed = () => {
  const { themeMode } = useSelector((state: RootState) => state.root);

  let logoFocusUrl = logoFocusCloudLightModeUrl;
  let logoBludataUrl = logoBludataWhiteModeUrl;
  let smallLogoUrl = logoFocusCloudSmallWhiteModeUrl;

  if (themeMode === 'dark') {
    logoFocusUrl = logoFocusCloudDarkModeUrl;
    logoBludataUrl = logoBludataDarkModeUrl;
    smallLogoUrl = logoFocusCloudSmallDarkModeUrl;
  }

  return {
    logoFocusUrl,
    logoBludataUrl,
    smallLogoUrl,
  };
};

export default useBludataLogoThemed;
